import { ValueFormatterParams } from "ag-grid-community";

export const NO_VALUE = "-";

export function dashOrValueFormatter<T>(value: ValueFormatterParams<T, string>): string {
    if (value.value === undefined || value.value === null || value.value === "") {
        return NO_VALUE;
    }
    return value.value;
}

export function dashOrEuDateFormatter<T>(value: ValueFormatterParams<T, string>): string {
    if (value.value === undefined || value.value === null || value.value === "") {
        return NO_VALUE;
    }
    return new Date(value.value).toLocaleDateString("en-GB");
}
